import { formatTime } from "@/shared/lib/date-time";
import { Alert, AlertDescription } from "@devhop/ui";
import { AlertTriangleIcon, UserIcon } from "lucide-react";
import type { RoomConflictResultDTO } from "../../domain/contracts/sessions";

type RoomConflictWarningProps = {
  conflictResult: RoomConflictResultDTO | null;
  message?: string;
};

export function RoomConflictWarning({
  conflictResult,
  message = "ຫ້ອງກຳລັງຖືກໃຊ້ງານໃນເວລານີ້.",
}: RoomConflictWarningProps) {
  if (!conflictResult?.hasConflict) return null;

  const hasRoomConflict = conflictResult.conflictingSessions.length > 0;
  const hasInstructorConflict =
    conflictResult.busyInstructors && conflictResult.busyInstructors.length > 0;

  return (
    <Alert className="border-red-200 bg-red-50 dark:bg-red-950/20">
      <AlertTriangleIcon className="size-4" />
      <AlertDescription className="text-red-900 dark:text-red-100">
        {hasRoomConflict ? message : null}
        {hasInstructorConflict ? (
          <>
            {hasRoomConflict && " "}
            ຄູທີ່ເລືອກບໍ່ວ່າງ:{" "}
            <strong>
              {conflictResult.busyInstructors.map((i) => i.name).join(", ")}
            </strong>
          </>
        ) : null}
      </AlertDescription>
      {hasInstructorConflict ? (
        <div className="mt-2 space-y-1 text-red-900 text-sm dark:text-red-100">
          <p className="font-semibold text-xs uppercase">ຄູທີ່ບໍ່ວ່າງໃນເວລານີ້</p>
          <ul className="list-inside list-disc">
            {conflictResult.busyInstructors.map((i) => (
              <li key={i.id}>{i.name}</li>
            ))}
          </ul>
        </div>
      ) : null}
      {hasRoomConflict ? (
        <div className="mt-2 space-y-1 text-red-900 text-sm dark:text-red-100">
          {conflictResult.conflictingSessions.map((s) => (
            <div key={s.id} className="flex items-center gap-2">
              <UserIcon className="size-3 shrink-0" />
              <span>
                {s.templateName} — {formatTime(s.startTime)}–
                {formatTime(s.endTime)}{" "}
                {Array.isArray(s.instructorNames) && s.instructorNames.length
                  ? `(${s.instructorNames.join(", ")})`
                  : ""}
              </span>
            </div>
          ))}
        </div>
      ) : null}
    </Alert>
  );
}
